import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const TlvIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("g", {
                clipPath: "url(#clip0_1158_10684)",
                children: /*#__PURE__*/ _jsx("path", {
                    d: "M5.28303 12.3016C5.35544 12.3258 5.45199 12.3016 5.47613 12.2289C5.47613 12.2047 6.61054 10.2438 8.51731 10.2438C8.83109 10.2438 9.169 10.2922 9.50691 10.4133L11.8481 16.9739C11.9205 17.1434 12.0895 17.2644 12.2585 17.2644C12.3067 17.2644 12.355 17.2644 12.4033 17.2402C12.6205 17.1676 12.7412 16.9013 12.6688 16.6834L10.3517 10.1712C11.0999 8.88809 12.2585 8.62179 13.1515 8.62179C13.9963 8.62179 14.6721 8.86388 14.6721 8.86388C14.7445 8.88809 14.8411 8.86388 14.8893 8.79125C15.8548 7.24187 17.5443 6.90295 18.7994 6.90295C19.4028 6.90295 19.8373 6.97557 19.8373 6.97557H19.8614C19.958 6.97557 20.0304 6.90295 20.0304 6.80611C20.0304 6.75769 20.0062 6.70927 19.9821 6.68506C19.7407 6.34614 16.9651 2.69058 11.8723 2.69058C10.593 2.69058 9.26554 2.90846 7.9139 3.36843L7.72081 2.78741C7.6484 2.56953 7.3829 2.44849 7.16567 2.52111C6.94845 2.59374 6.82776 2.86004 6.90017 3.07792L7.1174 3.65894C-0.630384 6.75769 -0.00283827 13.972 0.0212981 14.0446C0.0212981 14.1172 0.069571 14.1657 0.14198 14.1899C0.166117 14.1899 0.166117 14.1899 0.190253 14.1899C0.238526 14.1899 0.286799 14.1657 0.335071 14.1172C0.359208 14.093 1.97635 12.1079 4.14862 12.1079C4.51067 12.1321 4.89685 12.1805 5.28303 12.3016Z",
                    fill: "#FDAB3D"
                })
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_1158_10684",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "20",
                        height: "20",
                        fill: "white"
                    })
                })
            })
        ]
    });
